/* ============================================================================
   td-polypro-pdp.js — controller for sections/td-polypro-pdp.liquid
   Custom PolyPro Packing Tape PDP, with the live logo preview.

   Brief: briefs/polypro-preview-phase2-pdp-2026-10-09.md (2026-10-09). The page is
   the WAT page's pattern (td-wat-tape-pdp.js — its preview, zoom, pinned preview,
   popovers and bottom bar are ported here with the prefix renamed), the controls
   behave as the Phase 1 prototype's (qa/tape-preview-polypro/), and the PRICES are
   the previous PolyPro page's code, ported function for function.

   THE RULE THAT GOVERNS THIS FILE: no control the proof doesn't honour. Film,
   inks, layout, logo height and the SNAPPED spacing all ride the spec to the
   bridge (create-draft-checkout.js validatePolyproPreviewSpec), onto the order as
   properties, through n8n into buildTapeState, and into the proof and the plates.

   ⚠ ONE DELIBERATE CHANGE TO THE PORTED PRICING, display only: the tape line is
   shown as round2(unit) × qty, which is what the bridge CHARGES
   (create-draft-checkout.js prices the draft line at unitPrice.toFixed(2) × qty).
   The previous page showed the unrounded product — the FOCUS "display ≠ charge"
   defect. Nothing anyone is charged changes; the page now shows the charge.

   ⚠⚠ tapeColorMode MUST ship (Color background / PANTONE are +50%); see the bridge.
   ⚠ COLOURS COME FROM THE CONFIG (brief §3): stock_print_colors (incl. White) and
   tape_color_modes.color.swatches. The section's ink_color blocks are not read.
   ⚠ PolyPro sells RUNGS, not any number (the bridge refuses a non-rung quantity),
   and a printed background doubles the minimum (reverse_print.min_rolls).
   ========================================================================== */
(function () {
  'use strict';

  var root = document.querySelector('[data-pp]');
  if (!root) return;

  var STORAGE_KEY = 'tdPolyproPdpV2';   // V1 was the 2026-08-28 page's shape
  var STATE_PARAM = 'pp2';

  function readJSON(id, fallback) {
    var el = document.getElementById(id);
    if (!el) return fallback;
    try {
      var p = JSON.parse(el.textContent || 'null');
      if (Array.isArray(p)) return p.length ? p : fallback;
      return p && Object.keys(p).length ? p : fallback;
    } catch (e) { return fallback; }
  }

  var COPY = readJSON('pp-copy', {});
  var PLATES = readJSON('pp-plates', { base: '', sets: {} });

  // Design copy keyed to config ids (the config decides which exist).
  var GRADE_COPY = {
    GP:  { title: 'General',    sub: '1.9 mil · up to 30 lb' },
    HD:  { title: 'Heavy Duty', sub: '2.5 mil · 30–50 lb' },
    IND: { title: 'Industrial', sub: '3.0 mil · 60–90 lb' },
  };
  var WIDTH_COPY = { '2in': '2 in', '3in': '3 in' };
  var LENGTH_COPY = { '55yd': '55 yd', '110yd': '110 yd', '1000yd': '1,000 yd' };
  var NEUTRAL_COPY = { white: 'White', tan: 'Tan', clear: 'Clear' };

  var ORIENT = [
    { id: 'upright', n: 1 }, { id: 'rot180', n: 2 }, { id: 'rot90ccw', n: 3 }, { id: 'rot90cw', n: 4 },
    { id: 'step-repeat', n: null },
  ];
  var ORIENT_IDS = ORIENT.map(function (o) { return o.id; });

  // The preview's constants until the geometry module has loaded (asserted equal by
  // the QA harness). PolyPro webs: POLYPRO_WEB_MM {2:48, 3:72} in api/_lib/tape-spec.js.
  var WEB_IN = { '2in': 1.8898, '3in': 2.8346 };
  var HEIGHT_MIN_IN = 0.5, HEIGHT_STEP_IN = 0.05;
  // Default printed height per width. The brief's method (median of approved PolyPro
  // proofs) needs the n8n Fixer Push-Back history, unreachable when this shipped, so
  // this is its stated fallback: 60% of the web (cr, item 2).
  var HEIGHT_DEFAULT = { '2in': 1.13, '3in': 1.70 };
  var GAP_ASK_DEFAULT = 1;
  var PANTONE_GREY = '#9A9A9A';   // a PANTONE background previews grey: never an invented hex

  /* ── State ───────────────────────────────────────────────────────────── */

  var state = {
    config: null,
    grade: null, width: null, length: null, qty: null,
    tapeColorMode: 'neutral',
    tapeColor: 'white',
    pantoneTapeCode: '',
    printColors: '1',
    printColorSelections: { '1': 'black' },
    pantonePrintCodes: {},
    pantoneSlots: {},              // slot -> true while its PANTONE pill is chosen (UI)
    orient: 'upright',
    heightIn: null,                // null = the width's default until the customer moves the slider
    gapAskIn: GAP_ASK_DEFAULT,     // what the customer asked; snapped to the plate per render
    scene: 'roll',
    artworkMode: 'upload',
    artworkFile: null, artworkFilename: null, artworkThumb: null,
    designerNotes: '',
    proofEmail: '',
    discountCode: '', discountApplied: null,
  };

  var $  = function (s, c) { return (c || root).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || root).querySelectorAll(s)); };
  var fmt = function (n) { return '$' + Number(n).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); };
  var num = function (n) { return Number(n).toLocaleString('en-US'); };
  var esc = function (s) {
    return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  };
  var tok = function (t, map) { var out = String(t || ''); Object.keys(map).forEach(function (k) { out = out.split('%' + k + '%').join(String(map[k])); }); return out; };

  fetch(root.dataset.configUrl).then(function (r) { return r.json(); }).then(function (cfg) {
    state.config = cfg;
    seedDefaults();
    restoreFromUrlOrStorage();
    bindStaticHandlers();
    renderAll();
    Preview.boot();
  }).catch(function (e) {
    console.error('[pp] config load failed', e);
    var cta = $('[data-pp-cta]');
    if (cta) cta.textContent = 'Pricing unavailable — email support@tapedudes.com';
  });

  /* ── Defaults & persistence ──────────────────────────────────────────── */

  function seedDefaults() {
    var g = currentGrades(), w = currentWidths(), l = currentLengths();
    state.grade  = ((g.filter(function (x) { return x.default; })[0] || g[0]) || {}).id || 'GP';
    state.width  = ((w.filter(function (x) { return x.default; })[0] || w[0]) || {}).id || '2in';
    state.length = ((l.filter(function (x) { return x.default; })[0] || l[0]) || {}).id || '110yd';
    state.qty = (visibleTiers()[0] || {}).rolls || 36;
    state.tapeColor = (neutralTapeColors()[0] || {}).id || 'white';
    state.printColorSelections = { '1': 'black' };
  }

  function restoreFromUrlOrStorage() {
    try {
      var token = new URLSearchParams(location.search).get(STATE_PARAM);
      if (token) Object.assign(state, JSON.parse(atob(token)));
      else {
        var saved = sessionStorage.getItem(STORAGE_KEY);
        if (saved) Object.assign(state, JSON.parse(saved));
      }
    } catch (e) { /* ignore */ }
    sanitise();
  }

  // Every restored value is re-checked against the config, so a stale token can
  // never put the page into a state the engine cannot print or the bridge refuses.
  function sanitise() {
    if (ORIENT_IDS.indexOf(state.orient) === -1) state.orient = 'upright';
    if (['1', '2', '3'].indexOf(String(state.printColors)) === -1) state.printColors = '1';
    state.printColors = String(state.printColors);
    if (['neutral', 'color', 'pantone'].indexOf(state.tapeColorMode) === -1) state.tapeColorMode = 'neutral';
    if (!state.printColorSelections || typeof state.printColorSelections !== 'object') state.printColorSelections = {};
    if (!state.pantonePrintCodes || typeof state.pantonePrintCodes !== 'object') state.pantonePrintCodes = {};
    if (!state.pantoneSlots || typeof state.pantoneSlots !== 'object') state.pantoneSlots = {};
    for (var i = 1; i <= Number(state.printColors); i++) {
      var k = String(i);
      if (!inkById(state.printColorSelections[k])) state.printColorSelections[k] = 'black';
    }
    if (typeof state.pantoneTapeCode !== 'string') state.pantoneTapeCode = '';
    if (state.scene !== 'box') state.scene = 'roll';
    var h = Number(state.heightIn);
    state.heightIn = state.heightIn == null || !Number.isFinite(h) ? null : Math.max(HEIGHT_MIN_IN, h);
    var gq = Number(state.gapAskIn);
    state.gapAskIn = Number.isFinite(gq) && gq >= 0 ? gq : GAP_ASK_DEFAULT;
    pruneInkSlots();
    reconcileAfterGradeChange();
  }

  function pickSlim() {
    return {
      grade: state.grade, width: state.width, length: state.length, qty: state.qty,
      tapeColorMode: state.tapeColorMode, tapeColor: state.tapeColor, pantoneTapeCode: state.pantoneTapeCode,
      printColors: state.printColors, printColorSelections: state.printColorSelections,
      pantonePrintCodes: state.pantonePrintCodes, pantoneSlots: state.pantoneSlots,
      orient: state.orient, heightIn: state.heightIn, gapAskIn: state.gapAskIn, scene: state.scene,
      artworkMode: state.artworkMode, designerNotes: state.designerNotes,
    };
  }
  function persist() { try { sessionStorage.setItem(STORAGE_KEY, JSON.stringify(pickSlim())); } catch (e) { /* ignore */ } }

  /* ── Config readers (ported) ─────────────────────────────────────────── */

  function currentGrades()  { return (state.config.grades || {}).polypro || []; }
  function currentLengths() { return (state.config.lengths || {}).polypro || []; }
  function currentWidths()  { return state.config.widths || []; }
  function skuKey()         { return ['polypro', state.grade, state.width, state.length].join('|'); }
  function currentTiers()   { return state.config.pricing_matrix[skuKey()] || null; }

  // The inks and the colour backgrounds — ONE source, the config (brief §3).
  function stockInks() { return state.config.stock_print_colors || []; }
  function inkById(id) { return stockInks().filter(function (x) { return x.id === id; })[0] || null; }
  function colorTapeColors() { return ((state.config.tape_color_modes || {}).color || {}).swatches || []; }
  function neutralTapeColors() {
    var byGrade = (state.config.neutral_colors || {}).polypro || {};
    return byGrade[state.grade] || byGrade[(currentGrades()[0] || {}).id] || [];
  }

  // Reverse printing (a flood-coated base) runs at double the standard MOQ.
  function reverseActive() {
    var modes = ((state.config.reverse_print || {}).color_modes) || [];
    return modes.indexOf(state.tapeColorMode) !== -1;
  }
  function minRolls() {
    var tiers = currentTiers();
    if (!tiers || !tiers.length) return 0;
    if (!reverseActive()) return tiers[0].rolls;
    var m = ((state.config.reverse_print || {}).min_rolls || {})[skuKey()];
    return typeof m === 'number' ? m : tiers[0].rolls;
  }
  // FAILS OPEN, deliberately: never an empty ladder.
  function visibleTiers() {
    var tiers = currentTiers() || [];
    var min = minRolls();
    var v = tiers.filter(function (t) { return t.rolls >= min; });
    return v.length ? v : tiers;
  }

  function reconcileAfterGradeChange() {
    if (!currentGrades().some(function (g) { return g.id === state.grade; })) state.grade = (currentGrades()[0] || {}).id;
    if (!currentWidths().some(function (w) { return w.id === state.width; })) state.width = (currentWidths()[0] || {}).id;
    if (!currentLengths().some(function (l) { return l.id === state.length; })) state.length = (currentLengths()[0] || {}).id;
    // Industrial has no Tan: a stale neutral must not ride onto the order.
    if (state.tapeColorMode === 'neutral' && !neutralTapeColors().some(function (c) { return c.id === state.tapeColor; })) {
      state.tapeColor = (neutralTapeColors()[0] || {}).id || 'white';
    }
    if (state.tapeColorMode === 'color' && !colorTapeColors().some(function (c) { return c.id === state.tapeColor; })) {
      state.tapeColor = (colorTapeColors()[0] || {}).id;
    }
    reconcileQty();
  }

  // ⚠ Every grade / width / length / tape-mode change revalidates the quantity
  // BEFORE rendering (the 2026-09-03 PRICE_COMPUTE_FAILED trap): the bridge refuses
  // a quantity that is not an orderable rung of the selected row.
  function reconcileQty() {
    var tiers = visibleTiers();
    if (!tiers.length) return;
    if (!tiers.some(function (t) { return t.rolls === state.qty; })) state.qty = tiers[0].rolls;
  }
  function qtyValid() { return visibleTiers().some(function (t) { return t.rolls === state.qty; }); }

  /* ── Pricing — ported from the 2026-08-28 page (and v5 before it) ─────── */

  function applyModifiers(basePpr) {
    var p = basePpr;
    var cm = (state.config.tape_color_modes || {})[state.tapeColorMode];
    if (cm && cm.modifier_pct) p *= (1 + cm.modifier_pct / 100);
    var pc = state.config.print_colors.filter(function (x) { return x.id === state.printColors; })[0];
    if (pc && pc.modifier_pct) p *= (1 + pc.modifier_pct / 100);
    return p;
  }
  function priceEach() {
    var tiers = currentTiers();
    if (!tiers) return 0;
    var tier = tiers.filter(function (t) { return t.rolls === state.qty; })[0] || visibleTiers()[0];
    return applyModifiers(tier.ppr);
  }
  // round2 IS the bridge's rounding, which charges `unitPrice.toFixed(2) * quantity`.
  // ⚠ Not Math.round(n*100)/100: on a float half-cent tie (GP 2" 110yd Color, 7.815…)
  // the two disagree by 1¢ a roll, $4.68 on 468 rolls (qa/polypro-pdp.dom.cjs §6).
  function round2(n) { return Number(Number(n).toFixed(2)); }
  function tapeSubtotal() { return round2(priceEach()) * state.qty; }

  function pantoneSurcharge() { return state.config.tape_color_modes.pantone.flat_addon_per_color_usd; }
  function pantonePrintFee() {
    var fee = 0;
    for (var i = 1; i <= Number(state.printColors); i++) {
      if ((state.pantonePrintCodes[String(i)] || '').trim()) fee += pantoneSurcharge();
    }
    return fee;
  }
  function pantoneTapeFee() {
    if (state.tapeColorMode !== 'pantone') return 0;
    if (!(state.pantoneTapeCode || '').trim()) return 0;
    return pantoneSurcharge();
  }
  function totalPrice() { return tapeSubtotal() + pantoneTapeFee() + pantonePrintFee(); }
  function discountAmount(total) {
    if (!state.discountApplied) return 0;
    var dv = parseFloat(state.discountApplied.value);
    return state.discountApplied.value_type === 'percentage' ? total * dv / 100 : Math.min(dv, total);
  }
  function chargedTotal() { var t = totalPrice(); return t - discountAmount(t); }

  // A saving we CLAIM, rounded DOWN so it is never overstated, against the row's
  // first ORDERABLE rung (a reverse ladder starts above the row's first rung).
  function claimPct(tiers, ppr) { return Math.max(0, Math.floor((1 - ppr / tiers[0].ppr) * 100 + 1e-9)); }

  // A slot left in PANTONE mode carries no code yet: drop the keys above the slot
  // count so a stale code can never ride the reorder blob (as before).
  function pruneInkSlots() {
    var n = Number(state.printColors);
    [state.pantonePrintCodes, state.pantoneSlots, state.printColorSelections].forEach(function (m) {
      Object.keys(m).forEach(function (k) { var s = Number(k); if (!(s >= 1 && s <= n)) delete m[k]; });
    });
    for (var i = 1; i <= n; i++) {
      var k = String(i);
      if (!state.pantoneSlots[k]) delete state.pantonePrintCodes[k];
    }
  }
  // Inks the order can't be placed without: a PANTONE chosen but no code typed.
  function pantoneMissing() {
    if (state.tapeColorMode === 'pantone' && !(state.pantoneTapeCode || '').trim()) return 'tape';
    for (var i = 1; i <= Number(state.printColors); i++) {
      var k = String(i);
      if (state.pantoneSlots[k] && !(state.pantonePrintCodes[k] || '').trim()) return k;
    }
    return null;
  }

  /* ── What the controls MEAN (the film, the inks, the geometry) ─────────── */

  function filmId() { return state.tapeColorMode === 'neutral' ? state.tapeColor : state.tapeColorMode; }
  // The plates a film draws on: Color background and PANTONE print on WHITE film.
  function filmPlate() { return state.tapeColorMode === 'neutral' ? state.tapeColor : 'white'; }
  function floodHex() {
    if (state.tapeColorMode === 'color') { var c = colorTapeColors().filter(function (x) { return x.id === state.tapeColor; })[0]; return c ? String(c.hex).toUpperCase() : null; }
    if (state.tapeColorMode === 'pantone') return PANTONE_GREY;
    return null;
  }
  // The ink slots the PREVIEW separates into — the same shape the press's
  // separateInks() takes ([{ label, hex, pantone }]). Stock inks: the config's hex.
  // A PANTONE slot: no hex (it is painted in its own cluster colour, never invented).
  function inkSlots() {
    var out = [];
    for (var i = 1; i <= Number(state.printColors); i++) {
      var k = String(i);
      if (state.pantoneSlots[k]) {
        var code = (state.pantonePrintCodes[k] || '').trim();
        out.push({ label: 'PANTONE ' + (code || '?'), hex: null, pantone: code || '?' });
      } else {
        var ink = inkById(state.printColorSelections[k]) || inkById('black') || { label: 'Black', hex: '#1A1A1A' };
        out.push({ label: ink.label, hex: String(ink.hex).toUpperCase(), pantone: null });
      }
    }
    return out;
  }

  function widthNum() { return state.width === '3in' ? 3 : 2; }
  function geoOpts() { return { line: 'custom-tape', width: widthNum() }; }
  function engineWebIn() { return Math.max(8, Math.round((WEB_IN[state.width] || 1.8898) * 150)) / 150; }
  function maxHeightIn(layout) {
    var G = Preview.G, art = Preview.art && Preview.art.art;
    if (G && art) return G.maxHeightForArt(art, layout, geoOpts());
    if (G) return G.maxHeightIn(layout, geoOpts());
    var web = engineWebIn();
    return layout === 'step-repeat' ? Math.min(0.96, 0.72 - 0.28, 2 * 0.28, 2 * (1 - 0.72)) * web : 0.96 * web;
  }
  function wantHeight() { return state.heightIn == null ? HEIGHT_DEFAULT[state.width] || 1.13 : state.heightIn; }
  function clampHeight(h) { return Math.max(HEIGHT_MIN_IN, Math.min(maxHeightIn(state.orient), h)); }

  // The plate's reachable gaps for THIS artwork, size and layout, and the one nearest
  // what the customer asked. Null until the geometry module and the artwork exist.
  function spacing() {
    var G = Preview.G, a = Preview.art && Preview.art.art;
    if (!G || !a) return null;
    var g0 = G.impressionGeometry(a, { layout: state.orient, gapIn: 1, heightIn: clampHeight(wantHeight()), line: 'custom-tape', width: widthNum() });
    var stops = G.spacingStops(g0);
    if (!stops.length) return { stops: [], stop: null, tooLong: g0.plateTooLong };
    return { stops: stops, stop: G.snapGap(stops, state.gapAskIn), tooLong: false };
  }

  function effective() {
    var sp = spacing();
    return {
      plate: filmPlate(), flood: floodHex(), layout: state.orient,
      heightIn: clampHeight(wantHeight()), maxH: maxHeightIn(state.orient),
      gapIn: sp && sp.stop ? sp.stop.gapIn : state.gapAskIn, stops: sp ? sp.stops : [], stop: sp ? sp.stop : null,
      tooLong: !!(sp && sp.tooLong),
    };
  }

  function fmt2(x) { return (Math.floor(x * 100 + 1e-6) / 100).toFixed(2); }   // never overstate a max
  var r2 = function (x) { return Number(x).toFixed(2).replace(/\.?0+$/, ''); };

  /* ── Render ──────────────────────────────────────────────────────────── */

  function renderAll() {
    renderFilms();
    renderInks();
    renderOrientation();
    renderSizing();
    renderGrades();
    renderWidths();
    renderLengths();
    renderArtwork();
    renderQuantity();
    renderSummary();
    renderCta();
    renderUi();
    persist();
    Preview.refreshText();
  }

  /* TAPE — five tiles from the config's modes; the two printed bases open a row. */
  function renderFilms() {
    var wrap = $('[data-pp-films]');
    if (!wrap) return;
    var modes = state.config.tape_color_modes || {};
    var tiles = neutralTapeColors().map(function (c) {
      return { id: c.id, mode: 'neutral', title: NEUTRAL_COPY[c.id] || c.label, chip: c.id };
    });
    if (modes.color) tiles.push({ id: 'color', mode: 'color', title: modes.color.label || 'Color background', chip: 'color', pct: modes.color.modifier_pct });
    if (modes.pantone) tiles.push({ id: 'pantone', mode: 'pantone', title: 'PANTONE®', chip: 'pantone', pct: modes.pantone.modifier_pct });
    var cur = filmId();
    // 3 + 2 rows: the first three (the films) take a third each, the two printed
    // bases half each — or, on Industrial (no Tan), 2 + 2 at half each.
    var wide = tiles.length === 4 ? 4 : 2;
    wrap.innerHTML = tiles.map(function (t, i) {
      var on = t.id === cur;
      var isWide = tiles.length === 4 || i >= tiles.length - wide;
      return '<button type="button" class="pp__film' + (isWide ? ' pp__film--wide' : '') + (on ? ' is-selected' : '') + '" role="radio" aria-checked="' + on +
        '" data-pp-film="' + esc(t.id) + '" data-pp-film-mode="' + esc(t.mode) + '">' +
        '<span class="pp__film-chip pp__film-chip--' + esc(t.chip) + '"></span>' +
        '<span class="pp__film-title">' + esc(t.title) + (t.pct ? ' <span class="pp__film-pct">+' + t.pct + '%</span>' : '') + '</span>' +
      '</button>';
    }).join('');

    var line = $('[data-pp-tape-line]');
    if (line) {
      line.textContent = state.tapeColorMode === 'neutral'
        ? ({ white: 'Glossy white film', tan: 'Classic tan film', clear: 'Clear film, the box shows through' })[state.tapeColor] || ''
        : state.tapeColorMode === 'color' ? 'Printed background' : 'Your exact brand color';
    }

    var bgrow = $('[data-pp-bgrow]'), pms = $('[data-pp-pmsrow]');
    if (bgrow) bgrow.hidden = state.tapeColorMode !== 'color';
    if (pms) pms.hidden = state.tapeColorMode !== 'pantone';
    var sw = $('[data-pp-bgswatches]');
    if (sw && state.tapeColorMode === 'color') {
      sw.innerHTML = colorTapeColors().map(function (c) {
        var on = c.id === state.tapeColor;
        return '<button type="button" class="pp__sw2' + (on ? ' is-selected' : '') + '" role="radio" aria-checked="' + on + '" data-pp-bg="' + esc(c.id) +
          '" style="background:' + esc(c.hex) + '" title="' + esc(c.label) + '" aria-label="' + esc(c.label) + '"></button>';
      }).join('');
      var cur2 = colorTapeColors().filter(function (c) { return c.id === state.tapeColor; })[0] || {};
      var note = $('[data-pp-bgnote]');
      if (note) note.textContent = (cur2.label ? cur2.label + (cur2.pantone_code ? ' · ' + cur2.pantone_code : '') + ' · ' : '') +
        tok(COPY.colorBgNote || 'Printed edge to edge on white film · +%pct%%', { pct: (modes.color || {}).modifier_pct || 0 });
    }
    var tp = $('[data-pp-tape-pantone]');
    if (tp && document.activeElement !== tp) tp.value = state.pantoneTapeCode || '';
    if (tp) tp.classList.toggle('is-error', !!tp.dataset.err && !(state.pantoneTapeCode || '').trim());
    var pn = $('[data-pp-pmsnote]');
    if (pn) pn.textContent = tok(COPY.pantoneTapeNote || 'We match your PANTONE on your free proof · +%pct%% and $%price%',
      { pct: (modes.pantone || {}).modifier_pct || 0, price: pantoneSurcharge() });

    var rev = $('[data-pp-reverse-note]');
    if (rev) {
      var tiers = currentTiers(), min = minRolls();
      var show = reverseActive() && tiers && tiers.length && min > tiers[0].rolls;
      rev.hidden = !show;
      if (show) rev.textContent = tok(COPY.reverseMinNote || 'A printed background is reverse-printed, so this size runs at a %min%-roll minimum.', { min: num(min) });
    }
  }

  function setFilm(id, mode) {
    state.tapeColorMode = mode;
    if (mode === 'neutral') state.tapeColor = id;
    else if (mode === 'color') { if (!colorTapeColors().some(function (c) { return c.id === state.tapeColor; })) state.tapeColor = (colorTapeColors()[0] || {}).id; }
    else state.tapeColor = 'white';
    reconcileQty();               // ⚠ before render: Neutral → Color doubles most minimums
    renderAll();
    Preview.go('full');
  }

  /* INK COLORS — 1–3 slots: the config's stock inks (incl. White) or a PANTONE code. */
  function renderInks() {
    var wrap = $('[data-pp-inks]');
    if (!wrap) return;
    var n = Number(state.printColors);
    var label = COPY.inkLabel || 'Ink';
    var rows = [];
    for (var i = 1; i <= n; i++) {
      var k = String(i), pms = !!state.pantoneSlots[k], sel = state.printColorSelections[k];
      rows.push('<div class="pp__ink" data-pp-slot="' + k + '">' +
        '<span class="pp__ink-n">' + esc(label) + ' ' + i + '</span>' +
        '<span class="pp__ink-row" role="radiogroup" aria-label="' + esc(label + ' ' + i) + '">' +
          stockInks().map(function (ink) {
            var on = !pms && sel === ink.id;
            return '<button type="button" class="pp__ink-sw' + (on ? ' is-selected' : '') + '" role="radio" aria-checked="' + on + '" data-pp-ink="' + esc(ink.id) +
              '" style="background:' + esc(ink.hex) + '" title="' + esc(ink.label) + '" aria-label="' + esc(label + ' ' + i + ': ' + ink.label) + '"></button>';
          }).join('') +
          '<button type="button" class="pp__ink-pms' + (pms ? ' is-selected' : '') + '" role="radio" aria-checked="' + pms + '" data-pp-ink="pantone">PANTONE</button>' +
        '</span>' +
        (n > 1 ? '<button type="button" class="pp__ink-x" data-pp-ink-del aria-label="' + esc((COPY.inkRemove || 'Remove') + ' ' + label + ' ' + i) + '">' + esc(COPY.inkRemove || 'Remove') + '</button>' : '<span></span>') +
        (pms ? '<span class="pp__ink-pmsrow">' +
            '<input type="text" class="pp__input" data-pp-ink-code maxlength="40" autocomplete="off" spellcheck="false" value="' + esc(state.pantonePrintCodes[k] || '') + '"' +
            ' placeholder="' + esc(COPY.pantoneInkPlaceholder || 'PANTONE® code, e.g. 186 C') + '" aria-label="' + esc(label + ' ' + i + ' PANTONE code') + '">' +
            '<span class="pp__subnote">' + esc(tok(COPY.pantoneNote || 'Exact color match · +$%price% per color', { price: pantoneSurcharge() })) + '</span>' +
          '</span>' : '') +
      '</div>');
    }
    // Rebuilt only when the slot structure changes, so typing in a code keeps its caret.
    var sig = n + '|' + Object.keys(state.pantoneSlots).sort().join(',');
    if (wrap.dataset.sig !== sig) { wrap.innerHTML = rows.join(''); wrap.dataset.sig = sig; }
    else {
      $$('[data-pp-slot]', wrap).forEach(function (row) {
        var k = row.dataset.ppSlot, pms = !!state.pantoneSlots[k];
        $$('[data-pp-ink]', row).forEach(function (b) {
          var on = b.dataset.ppInk === 'pantone' ? pms : (!pms && state.printColorSelections[k] === b.dataset.ppInk);
          b.classList.toggle('is-selected', on); b.setAttribute('aria-checked', on ? 'true' : 'false');
        });
      });
    }
    $$('[data-pp-ink-code]', wrap).forEach(function (inp) {
      var k = inp.closest('[data-pp-slot]').dataset.ppSlot;
      inp.classList.toggle('is-error', !!inp.dataset.err && !(state.pantonePrintCodes[k] || '').trim());
    });
    var add = $('[data-pp-add-ink]');
    if (add) add.hidden = n >= 3;
    var line = $('[data-pp-inks-line]');
    if (line) {
      var pc = state.config.print_colors.filter(function (x) { return x.id === state.printColors; })[0];
      line.textContent = n + (n === 1 ? ' ink' : ' inks') + (pc && pc.modifier_pct ? ' · +' + pc.modifier_pct + '%' : ' · ' + (COPY.included || 'Included'));
    }
  }

  function inksChanged() {
    pruneInkSlots();
    renderInks(); renderQuantity(); renderSummary(); renderCta(); renderUi(); persist();
    Preview.go('full');
  }

  /* LAYOUT */
  function renderOrientation() {
    $$('[data-pp-orient]').forEach(function (el) {
      var on = el.dataset.ppOrient === state.orient;
      el.classList.toggle('is-selected', on);
      el.setAttribute('aria-checked', on ? 'true' : 'false');
    });
  }
  function setOrient(id) {
    state.orient = id;
    renderOrientation(); renderSizing(); renderSummary(); renderUi(); persist();
    Preview.go('full');
  }

  /* LOGO SIZE & SPACING — the spacing slider is an INDEX into the plate's gaps. */
  function renderSizing() {
    var e = effective();
    var size = $('[data-pp-size]');
    if (size) {
      size.max = String(e.maxH);
      if (document.activeElement !== size) size.value = String(e.heightIn);
    }
    var out = $('[data-pp-size-out]');
    if (out) out.textContent = fmt2(e.heightIn);
    var gap = $('[data-pp-gap]'), gout = $('[data-pp-gap-out]'), gper = $('[data-pp-gap-per]');
    if (gap) {
      gap.disabled = !e.stops.length;
      gap.max = String(Math.max(0, e.stops.length - 1));
      if (document.activeElement !== gap) gap.value = String(Math.max(0, e.stops.indexOf(e.stop)));
    }
    if (gout) gout.textContent = e.stop ? r2(e.stop.gapIn) : '—';
    if (gper) gper.textContent = e.stop ? e.stop.n + ' per 8 in' : (e.tooLong ? 'too long for the plate' : 'add your logo');
    paintRange(size); paintRange(gap);
  }
  function paintRange(el) {
    if (!el) return;
    var min = Number(el.min), max = Number(el.max), v = Number(el.value);
    el.style.setProperty('--pp-f', String(max > min ? Math.max(0, Math.min(1, (v - min) / (max - min))) : 0));
  }

  /* GRADE / WIDTH / LENGTH — segments, built from the config */
  function segs(sel, items, cur, attr, render2) {
    var wrap = $(sel);
    if (!wrap) return;
    wrap.innerHTML = items.map(function (it) {
      var on = it.id === cur;
      return '<button type="button" class="pp__segbtn' + (on ? ' is-selected' : '') + '" role="radio" aria-checked="' + on + '" data-pp-' + attr + '="' + esc(it.id) + '">' + render2(it) + '</button>';
    }).join('');
  }
  // Titles on the tiles; the selected grade's thickness and box weight in the header
  // (a sub-line on three tiles in a ~90px column wrapped to three lines).
  function renderGrades() {
    segs('[data-pp-grades]', currentGrades(), state.grade, 'grade', function (g) {
      return esc((GRADE_COPY[g.id] || {}).title || g.label);
    });
    var line = $('[data-pp-grade-line]');
    if (line) line.textContent = (GRADE_COPY[state.grade] || {}).sub || '';
  }
  function renderWidths() { segs('[data-pp-widths]', currentWidths(), state.width, 'width', function (w) { return esc(WIDTH_COPY[w.id] || w.label); }); }
  function renderLengths() {
    segs('[data-pp-lengths]', currentLengths(), state.length, 'length', function (l) { return esc(LENGTH_COPY[l.id] || l.label); });
    var box = $('[data-pp-machine-warn]');
    if (box) {
      var len = currentLengths().filter(function (l) { return l.id === state.length; })[0];
      box.hidden = !(len && len.machine_only);
    }
  }

  /* UPLOAD */
  function renderArtwork() {
    var empty = $('[data-pp-drop-empty]'), filled = $('[data-pp-drop-filled]'), hasFile = !!state.artworkFile;
    if (empty) empty.hidden = hasFile;
    if (filled) filled.hidden = !hasFile;
    var dropEl = $('[data-pp-drop]');
    if (dropEl) dropEl.classList.toggle('is-filled', hasFile);
    if (hasFile) {
      var nameEl = $('[data-pp-file-name]');
      if (nameEl) nameEl.textContent = state.artworkFilename || '';
      var thumb = $('[data-pp-thumb]');
      if (thumb) thumb.style.backgroundImage = state.artworkThumb ? 'url(' + state.artworkThumb + ')' : '';
      if (thumb && thumb.parentNode) thumb.parentNode.classList.toggle('is-img', !!state.artworkThumb);
      var ext = $('[data-pp-ext]');
      if (ext) {
        var m = String(state.artworkFilename || '').match(/\.([a-z0-9]+)$/i);
        ext.textContent = m ? '.' + m[1].toUpperCase() : '';
        ext.hidden = !!state.artworkThumb;
      }
    }
    var textBtn = $('[data-pp-text]');
    if (textBtn) {
      var textOn = state.artworkMode === 'text';
      textBtn.classList.toggle('is-selected', textOn);
      textBtn.setAttribute('aria-pressed', textOn ? 'true' : 'false');
      if (!textBtn.dataset.offLabel) textBtn.dataset.offLabel = textBtn.textContent;
      textBtn.textContent = textOn ? (COPY.plainTextOn || 'Using plain text — upload a file instead') : textBtn.dataset.offLabel;
      textBtn.hidden = hasFile;
    }
    var status = $('[data-pp-drop-status]');
    if (status && !status.dataset.sticky) {
      if (state.artworkMode === 'text' && !hasFile) {
        status.textContent = COPY.plainTextNote || '';
        status.hidden = false; status.className = 'pp__drop-status';
      } else status.hidden = true;
    }
    var notes = $('[data-pp-notes]');
    if (notes && notes.value !== state.designerNotes) notes.value = state.designerNotes;
    var sThumb = $('[data-pp-sum-thumb]'), sIcon = $('[data-pp-sum-icon]');
    if (sThumb) { sThumb.style.backgroundImage = state.artworkThumb ? 'url(' + state.artworkThumb + ')' : ''; sThumb.hidden = !state.artworkThumb; }
    if (sIcon) sIcon.hidden = !!state.artworkThumb;
  }
  function dropStatus(msg, kind) {
    var status = $('[data-pp-drop-status]');
    if (!status) return;
    if (!msg) { status.hidden = true; delete status.dataset.sticky; renderArtwork(); return; }
    status.textContent = msg; status.hidden = false;
    status.className = 'pp__drop-status' + (kind ? ' pp__drop-status--' + kind : '');
    if (kind === 'error') status.dataset.sticky = '1'; else delete status.dataset.sticky;
  }
  var PREVIEWABLE = ['.png', '.jpg', '.jpeg', '.gif', '.webp', '.svg'];
  function handleFile(file) {
    if (!file) return;
    var maxMb = state.config.artwork.max_size_mb;
    if (file.size > maxMb * 1024 * 1024) { dropStatus('This file is over ' + maxMb + ' MB. Please upload a smaller version of your logo.', 'error'); return; }
    state.artworkFilename = file.name; state.artworkFile = file; state.artworkMode = 'upload'; state.artworkThumb = null;
    dropStatus(null);
    var lower = file.name.toLowerCase();
    var canPreview = PREVIEWABLE.some(function (e) { return lower.slice(-e.length) === e; });
    if (canPreview) {
      var reader = new FileReader();
      reader.onload = function (e) { state.artworkThumb = e.target.result; renderArtwork(); };
      reader.readAsDataURL(file);
    }
    renderArtwork(); renderSummary(); renderCta(); persist();
    Preview.setFile(file, canPreview);
    renderUi();
  }

  /* QUANTITY — three buttons (the row's first three orderable rungs) + the table.
     ⚠ The button row is rebuilt only when the ROW or the modifiers change: a rebuild
     between mousedown and mouseup detaches the button and the tap is lost. */
  var qtyBuiltFor = '';
  function renderQuantity() {
    var tiers = visibleTiers();
    var wrap = $('[data-pp-qty-chips]'), vt = $('[data-pp-vtable]');
    if (!tiers.length) return;
    // A rung picked from the Volume pricing table takes the third button's place, so
    // the choice is always one of the three visible buttons (no extra line to explain it).
    var shown = tiers.slice(0, 3);
    var picked = tiers.filter(function (t) { return t.rolls === state.qty; })[0];
    if (picked && shown.indexOf(picked) === -1) shown[2] = picked;
    var key = skuKey() + '|' + state.tapeColorMode + '|' + state.printColors + '|' + shown.map(function (t) { return t.rolls; }).join(',');
    if (key !== qtyBuiltFor) {
      qtyBuiltFor = key;
      if (wrap) wrap.innerHTML = shown.map(function (t) {
        var pct = t === tiers[0] ? 0 : claimPct(tiers, t.ppr);
        return '<button type="button" class="pp__tier" data-pp-qty-chip="' + t.rolls + '" aria-pressed="false">' +
          '<span class="pp__tier-n"><b>' + num(t.rolls) + '</b> rolls</span>' +
          '<span class="pp__tier-p">' + esc(fmt(round2(applyModifiers(t.ppr)))) + '/roll</span>' +
          (pct > 0 ? '<span class="pp__tier-save">Save ' + pct + '%</span>' : '') +
        '</button>';
      }).join('');
      if (vt) vt.innerHTML = tiers.map(function (t, i) {
        var pct = i ? claimPct(tiers, t.ppr) : 0;
        return '<tr data-pp-vrow="' + t.rolls + '" tabindex="0"><td>' + num(t.rolls) + '</td><td>' + esc(fmt(round2(applyModifiers(t.ppr)))) + '</td><td>' + (pct > 0 ? pct + '%' : '—') + '</td></tr>';
      }).join('');
    }
    $$('[data-pp-qty-chip]').forEach(function (b) {
      var on = Number(b.dataset.ppQtyChip) === state.qty;
      b.classList.toggle('is-selected', on); b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    $$('[data-pp-vrow]').forEach(function (r) {
      var on = Number(r.dataset.ppVrow) === state.qty;
      r.classList.toggle('is-current', on);
      if (on) r.setAttribute('aria-current', 'true'); else r.removeAttribute('aria-current');
    });
    var aside = $('[data-pp-qty-aside]');
    if (aside) aside.textContent = 'From ' + num(tiers[0].rolls) + ' rolls';
    var msg = $('[data-pp-qty-msg]');
    if (msg) msg.hidden = true;
  }
  function setQty(q) {
    if (!visibleTiers().some(function (t) { return t.rolls === q; })) return;
    state.qty = q;
    renderQuantity(); renderSummary(); renderCta(); persist(); Preview.refreshText();
  }

  function layoutName() {
    var o = ORIENT.filter(function (x) { return x.id === state.orient; })[0] || ORIENT[0];
    return o.n ? 'orientation ' + o.n : 'step & repeat';
  }
  function baseSpec() {
    if (state.tapeColorMode === 'color') { var c = colorTapeColors().filter(function (x) { return x.id === state.tapeColor; })[0] || {}; return (c.label || state.tapeColor) + ' background'; }
    if (state.tapeColorMode === 'pantone') return 'PANTONE® ' + ((state.pantoneTapeCode || '').trim() || 'background');
    return (NEUTRAL_COPY[state.tapeColor] || state.tapeColor) + ' film';
  }
  function inksSpec() {
    return inkSlots().map(function (s) { return s.pantone ? 'PANTONE ' + s.pantone : s.label; }).join(' + ');
  }

  function renderSummary() {
    var tiers = currentTiers();
    if (!tiers || !tiers.length) return;
    var grade = currentGrades().filter(function (g) { return g.id === state.grade; })[0] || {};
    var e = effective();
    var head = $('[data-pp-sum-headline]');
    if (head) head.textContent = num(state.qty) + ' rolls · ' + layoutName();
    var spec = $('[data-pp-sum-spec]');
    if (spec) spec.textContent = [grade.label || state.grade, WIDTH_COPY[state.width], LENGTH_COPY[state.length], baseSpec(), inksSpec(),
      fmt2(e.heightIn) + '" logo' + (e.stop ? ', ' + r2(e.stop.gapIn) + '" apart' : '')].join(' · ');

    var vTiers = visibleTiers();
    var listPer = round2(applyModifiers(vTiers[0].ppr));   // the entry rung's unit price, as charged
    var listTot = listPer * state.qty;
    var subtotal = tapeSubtotal();
    var disc = listTot - subtotal;
    var total = totalPrice();
    var coupon = discountAmount(total);
    var rows = [{ label: 'Tape · ' + num(state.qty) + ' × ' + fmt(listPer), value: fmt(listTot) }];
    if (disc > 0.005) {
      var cur = vTiers.filter(function (t) { return t.rolls === state.qty; })[0] || vTiers[0];
      rows.push({ label: 'Volume discount (' + claimPct(vTiers, cur.ppr) + '%)', value: '−' + fmt(disc), green: true });
    }
    // Two sources, two rows (as before): a PANTONE background and PANTONE inks are separate $100s.
    if (pantoneTapeFee() > 0) rows.push({ label: 'PANTONE® background', value: fmt(pantoneTapeFee()) });
    var inkP = pantonePrintFee();
    if (inkP > 0) { var c = Math.round(inkP / pantoneSurcharge()); rows.push({ label: 'PANTONE® print (' + c + (c === 1 ? ' color)' : ' colors)'), value: fmt(inkP) }); }
    rows.push({ label: COPY.plateFeeLabel || 'Plate fee (one-time)', value: 'Free', green: true });
    var shipFree = state.config.fees.shipping === 'FREE';
    rows.push({ label: COPY.shippingLabel || 'Shipping', value: shipFree ? 'Free' : String(state.config.fees.shipping), green: shipFree });
    if (coupon > 0.005) rows.push({ label: 'Discount (' + state.discountApplied.code + ')', value: '−' + fmt(coupon), green: true });

    var rowsEl = $('[data-pp-sum-rows]');
    if (rowsEl) rowsEl.innerHTML = rows.map(function (r) {
      return '<div class="pp__sumrow"><span>' + esc(r.label) + '</span><span class="pp__sumval' + (r.green ? ' pp__sumval--green' : '') + '">' + esc(r.value) + '</span></div>';
    }).join('');
    var totalEl = $('[data-pp-total]');
    if (totalEl) totalEl.textContent = fmt(chargedTotal());
    var sub = $('[data-pp-total-sub]');
    if (sub) {
      var nP = (pantoneTapeFee() > 0 ? 1 : 0) + (inkP > 0 ? Math.round(inkP / pantoneSurcharge()) : 0);
      sub.textContent = num(state.qty) + ' rolls × ' + fmt(round2(priceEach())) + (nP ? ' + PANTONE' : '');
    }
    renderBarTotal();
  }
  function renderBarTotal() {
    var b = $('[data-pp-bar-total]');
    if (b) b.textContent = qtyValid() ? fmt(chargedTotal()) : '—';
    var bs = $('[data-pp-bar-sub]');
    if (bs) bs.textContent = qtyValid() ? num(state.qty) + ' rolls · ' + (COPY.barSub || 'free proof') : '';
  }

  function renderCta() {
    var cta = $('[data-pp-cta]');
    if (!cta) return;
    var art = !!state.artworkFile || state.artworkMode === 'text';
    var pms = pantoneMissing();
    var ready = art && qtyValid() && !pms;
    cta.classList.toggle('is-ready', ready);
    cta.disabled = !ready;
    cta.textContent = ready ? (COPY.ctaLabel || 'Continue to checkout')
      : (!art ? (COPY.ctaIdle || 'Upload artwork to continue') : (COPY.ctaPantone || 'Enter your PANTONE code to continue'));
  }

  /* ── Static handlers ─────────────────────────────────────────────────── */

  function onKeyPick(el, fn) {
    el.addEventListener('click', fn);
    el.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); fn(); } });
  }

  function bindStaticHandlers() {
    $$('[data-pp-orient]').forEach(function (el) { onKeyPick(el, function () { setOrient(el.dataset.ppOrient); }); });

    var films = $('[data-pp-films]');
    if (films) films.addEventListener('click', function (e) {
      var b = e.target.closest ? e.target.closest('[data-pp-film]') : null;
      if (b) setFilm(b.dataset.ppFilm, b.dataset.ppFilmMode);
    });
    var bgs = $('[data-pp-bgswatches]');
    if (bgs) bgs.addEventListener('click', function (e) {
      var b = e.target.closest ? e.target.closest('[data-pp-bg]') : null;
      if (!b) return;
      state.tapeColor = b.dataset.ppBg;
      renderFilms(); renderSummary(); persist(); Preview.go('full');
    });
    var tp = $('[data-pp-tape-pantone]');
    if (tp) tp.addEventListener('input', function () {
      state.pantoneTapeCode = tp.value; delete tp.dataset.err;
      renderFilms(); renderSummary(); renderCta(); persist(); Preview.refreshText();
    });

    var inks = $('[data-pp-inks]');
    if (inks) {
      inks.addEventListener('click', function (e) {
        var row = e.target.closest ? e.target.closest('[data-pp-slot]') : null;
        if (!row) return;
        var k = row.dataset.ppSlot;
        if (e.target.closest('[data-pp-ink-del]')) {
          // remove slot k: shift the slots above it down
          var n = Number(state.printColors), sel = {}, codes = {}, pms = {};
          for (var i = 1, j = 1; i <= n; i++) {
            if (String(i) === k) continue;
            var a = String(i), b = String(j++);
            sel[b] = state.printColorSelections[a]; if (state.pantonePrintCodes[a]) codes[b] = state.pantonePrintCodes[a]; if (state.pantoneSlots[a]) pms[b] = true;
          }
          state.printColorSelections = sel; state.pantonePrintCodes = codes; state.pantoneSlots = pms;
          state.printColors = String(n - 1);
          return inksChanged();
        }
        var b2 = e.target.closest('[data-pp-ink]');
        if (!b2) return;
        if (b2.dataset.ppInk === 'pantone') state.pantoneSlots[k] = true;
        else { delete state.pantoneSlots[k]; delete state.pantonePrintCodes[k]; state.printColorSelections[k] = b2.dataset.ppInk; }
        inksChanged();
        if (b2.dataset.ppInk === 'pantone') { var f = $('[data-pp-slot="' + k + '"] [data-pp-ink-code]'); if (f) f.focus(); }
      });
      inks.addEventListener('input', function (e) {
        var f = e.target.closest ? e.target.closest('[data-pp-ink-code]') : null;
        if (!f) return;
        var k = f.closest('[data-pp-slot]').dataset.ppSlot;
        state.pantonePrintCodes[k] = f.value; delete f.dataset.err;
        renderSummary(); renderCta(); persist(); Preview.go('full');
      });
    }
    var add = $('[data-pp-add-ink]');
    if (add) add.addEventListener('click', function () {
      var n = Number(state.printColors);
      if (n >= 3) return;
      var used = Object.keys(state.printColorSelections).map(function (k) { return state.printColorSelections[k]; });
      var next = stockInks().filter(function (x) { return used.indexOf(x.id) === -1 && x.id !== 'white'; })[0] || stockInks()[0];
      state.printColors = String(n + 1);
      state.printColorSelections[String(n + 1)] = next ? next.id : 'black';
      inksChanged();
    });

    // Logo size: 0.05" steps, plus this artwork's exact maximum as the last stop.
    var size = $('[data-pp-size]');
    if (size) {
      size.addEventListener('input', function () {
        var mx = maxHeightIn(state.orient), raw = Number(size.value);
        state.heightIn = mx - raw < HEIGHT_STEP_IN / 2 ? mx : Math.round(raw / HEIGHT_STEP_IN) * HEIGHT_STEP_IN;
        var out = $('[data-pp-size-out]');
        if (out) out.textContent = fmt2(clampHeight(state.heightIn));
        paintRange(size);
        renderSizingGapOnly();
        Preview.go('drag');
      });
      size.addEventListener('change', function () { renderSizing(); renderSummary(); renderUi(); persist(); Preview.go('full'); });
    }
    // Spacing: the slider can only land on a gap the 8" plate holds.
    var gap = $('[data-pp-gap]');
    if (gap) {
      gap.addEventListener('input', function () {
        var st = effective().stops[Number(gap.value)];
        if (st) state.gapAskIn = st.gapIn;
        renderSizingGapOnly(); paintRange(gap);
        Preview.go('drag');
      });
      gap.addEventListener('change', function () { renderSummary(); renderUi(); persist(); Preview.go('full'); });
    }

    $$('[data-pp-scene]').forEach(function (b) {
      b.addEventListener('click', function () { state.scene = b.dataset.ppScene; persist(); Preview.go('full'); });
    });

    root.addEventListener('click', function (e) {
      var g = e.target.closest ? e.target.closest('[data-pp-grade]') : null;
      if (g) { state.grade = g.dataset.ppGrade; reconcileAfterGradeChange(); renderAll(); Preview.go('full'); return; }
      var w = e.target.closest ? e.target.closest('[data-pp-width]') : null;
      if (w) { state.width = w.dataset.ppWidth; reconcileQty(); renderAll(); Preview.go('full'); return; }
      var l = e.target.closest ? e.target.closest('[data-pp-length]') : null;
      if (l) { state.length = l.dataset.ppLength; reconcileQty(); renderAll(); return; }
      var q = e.target.closest ? e.target.closest('[data-pp-qty-chip], [data-pp-vrow]') : null;
      if (q) setQty(Number(q.dataset.ppQtyChip || q.dataset.ppVrow));
    });
    root.addEventListener('keydown', function (e) {
      var q = e.target.closest ? e.target.closest('[data-pp-vrow]') : null;
      if (q && (e.key === 'Enter' || e.key === ' ')) { e.preventDefault(); setQty(Number(q.dataset.ppVrow)); }
    });

    var fileInput = $('[data-pp-file]'), drop = $('[data-pp-drop]');
    if (fileInput) fileInput.addEventListener('change', function (e) { handleFile(e.target.files[0]); });
    if (drop && fileInput) {
      drop.addEventListener('click', function (e) { if (e.target.closest('[data-pp-text]')) return; fileInput.click(); });
      ['dragover', 'dragleave', 'drop'].forEach(function (evt) { drop.addEventListener(evt, function (e) { e.preventDefault(); }); });
      drop.addEventListener('dragover', function () { drop.classList.add('is-drag'); });
      drop.addEventListener('dragleave', function () { drop.classList.remove('is-drag'); });
      drop.addEventListener('drop', function (e) { drop.classList.remove('is-drag'); handleFile(e.dataTransfer.files[0]); });
    }
    var textBtn = $('[data-pp-text]');
    if (textBtn) textBtn.addEventListener('click', function (e) {
      e.preventDefault(); e.stopPropagation();
      state.artworkMode = state.artworkMode === 'text' ? 'upload' : 'text';
      if (state.artworkMode === 'text') { state.artworkFile = null; state.artworkFilename = null; state.artworkThumb = null; Preview.setFile(null, false); }
      dropStatus(null);
      renderArtwork(); renderSummary(); renderCta(); persist(); renderUi();
    });
    var notes = $('[data-pp-notes]');
    if (notes) notes.addEventListener('input', function (e) { state.designerNotes = e.target.value; persist(); });

    var cta = $('[data-pp-cta]');
    if (cta) cta.addEventListener('click', openProofModal);

    bindCouponHandlers();
    Ui.bind(); Pin.bind(); Guide.bind(); QtyPop.bind(); Zoom.bind();
  }

  // The size slider moves the spacing stops (the along-run changes): text only, no rebuild.
  function renderSizingGapOnly() {
    var e = effective();
    var gap = $('[data-pp-gap]'), gout = $('[data-pp-gap-out]'), gper = $('[data-pp-gap-per]');
    if (gap) { gap.max = String(Math.max(0, e.stops.length - 1)); gap.disabled = !e.stops.length; if (document.activeElement !== gap) gap.value = String(Math.max(0, e.stops.indexOf(e.stop))); paintRange(gap); }
    if (gout) gout.textContent = e.stop ? r2(e.stop.gapIn) : '—';
    if (gper) gper.textContent = e.stop ? e.stop.n + ' per 8 in' : (e.tooLong ? 'too long for the plate' : 'add your logo');
  }

  /* ── Checkout gate ─────────────────────────────────────────────────── */

  function flagPantone(which) {
    var el = which === 'tape' ? $('[data-pp-tape-pantone]') : $('[data-pp-slot="' + which + '"] [data-pp-ink-code]');
    if (!el) return;
    el.dataset.err = '1'; el.classList.add('is-error');
    if (el.scrollIntoView) el.scrollIntoView({ behavior: 'smooth', block: 'center' });
    if (el.focus) el.focus({ preventScroll: true });
  }
  function openProofModal() {
    if (!qtyValid()) { reconcileQty(); renderAll(); return; }
    if (state.artworkMode === 'upload' && !state.artworkFile) {
      dropStatus(COPY.uploadRequired || 'Please upload your artwork to continue.', 'error');
      var d = $('[data-pp-drop]');
      if (d && d.scrollIntoView) d.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }
    var pms = pantoneMissing();
    if (pms) { flagPantone(pms); return; }
    checkout();
  }

  /* ── Checkout bridge ───────────────────────────────────────────────────── */

  var CLOUDINARY_UPLOAD = { url: 'https://api.cloudinary.com/v1_1/dsbz1mtmr/auto/upload', preset: 'tapedudes_unsigned', folder: 'orders' };

  /* SVG normalisation: Cloudinary sniffs an SVG from its FIRST BYTES; without an XML
     declaration at byte 0 the unsigned preset rejects it (order #2869). Fails open. */
  var TD_XML_DECL = '<?xml version="1.0" encoding="UTF-8"?>\n';
  function normalizeSvg(file) {
    var name = file && file.name ? String(file.name).toLowerCase() : '';
    var looksSvg = !!file && (file.type === 'image/svg+xml' || /\.svg$/.test(name));
    if (!looksSvg || !file.slice || !file.slice(0, 1).arrayBuffer) return Promise.resolve(file);
    return file.slice(0, 1024).arrayBuffer().then(function (buf) {
      var b = new Uint8Array(buf), i = 0;
      if (b[0] === 0xEF && b[1] === 0xBB && b[2] === 0xBF) i = 3;
      while (i < b.length && (b[i] === 0x20 || b[i] === 0x09 || b[i] === 0x0A || b[i] === 0x0D)) i++;
      var head = new TextDecoder().decode(b.subarray(i));
      if (/^<\?xml[\s?]/.test(head)) return i === 0 ? file : new File([file.slice(i)], file.name, { type: 'image/svg+xml' });
      if (!/<svg[\s>]/i.test(head)) return file;
      return new File([TD_XML_DECL, file.slice(i)], file.name, { type: 'image/svg+xml' });
    })['catch'](function () { return file; });
  }
  function uploadArtwork(file) {
    return normalizeSvg(file).then(function (f) {
      var fd = new FormData();
      fd.append('file', f); fd.append('upload_preset', CLOUDINARY_UPLOAD.preset); fd.append('folder', CLOUDINARY_UPLOAD.folder);
      return fetch(CLOUDINARY_UPLOAD.url, { method: 'POST', body: fd })
        .then(function (res) { if (!res.ok) throw new Error('upload HTTP ' + res.status); return res.json(); })
        .then(function (j) { if (!j || !j.public_id) throw new Error('no public_id'); return { secure_url: j.secure_url, public_id: j.public_id }; });
    });
  }
  function withTimeout(p, ms) { return Promise.race([p, new Promise(function (_, rej) { setTimeout(function () { rej(new Error('timeout')); }, ms); })]); }
  async function computeHmacHex(payload, nonce) {
    var enc = new TextEncoder();
    var key = await crypto.subtle.importKey('raw', enc.encode(nonce), { name: 'HMAC', hash: 'SHA-256' }, false, ['sign']);
    var sig = await crypto.subtle.sign('HMAC', key, enc.encode(JSON.stringify(payload)));
    return Array.prototype.slice.call(new Uint8Array(sig)).map(function (b) { return b.toString(16).padStart(2, '0'); }).join('');
  }

  // The spec the bridge prices and stamps: the previous page's keys, plus the Phase 2
  // fields (logo_height_in, the SNAPPED gap_in, the preview), each optional and
  // validated by create-draft-checkout.js validatePolyproPreviewSpec.
  function buildSpec() {
    var e = effective();
    var sel = {}, codes = {};
    for (var i = 1; i <= Number(state.printColors); i++) {
      var k = String(i);
      sel[k] = state.printColorSelections[k] || 'black';
      if (state.pantoneSlots[k] && (state.pantonePrintCodes[k] || '').trim()) codes[k] = state.pantonePrintCodes[k].trim();
    }
    var spec = {
      material: 'polypro',
      grade: state.grade,
      width: state.width,
      length: state.length,
      qty: state.qty,
      tapeColorMode: state.tapeColorMode,       // ⚠ must ship: +50% on color / pantone
      tapeColor: state.tapeColor,
      pantoneTapeCode: state.tapeColorMode === 'pantone' ? (state.pantoneTapeCode || '').trim() : '',
      printColors: state.printColors,
      printColorSelections: sel,
      pantonePrintCodes: codes,
      artworkMode: state.artworkMode,
      artworkFilename: state.artworkFilename || '',
      designerNotes: state.designerNotes || '',
      printLayout: state.orient,                // upright | rot180 | rot90ccw | rot90cw | step-repeat
      logoRepeat: 'normal',                     // dropped by the bridge once gap_in is present
      proof_email: state.proofEmail || '',
      // ── Phase 2 ──
      logo_height_in: Math.round(e.heightIn * 10000) / 10000,
      preview_shown: Preview.shownForThisFile() ? 'yes' : 'no',
    };
    // The snapped gap only when the page could snap it (artwork in the preview).
    if (e.stop) spec.gap_in = Math.round(e.stop.gapIn * 10000) / 10000;
    return spec;
  }

  async function checkout() {
    if (!qtyValid()) return;
    var cta = $('[data-pp-cta]');
    var restore = cta ? cta.textContent : '';
    if (cta) { cta.disabled = true; cta.textContent = 'Preparing your checkout…'; }
    var spec = buildSpec();
    var payload = { product_type: root.dataset.productType || 'custom-poly-tape', variant_id: root.dataset.variantId, quantity: state.qty, spec: spec };
    if (state.discountApplied) payload.discount_code = state.discountApplied.code;
    // Uploads BEFORE the HMAC (payload.spec is the same object); neither failure blocks checkout.
    var tasks = [];
    if (state.artworkFile) tasks.push(uploadArtwork(state.artworkFile).then(function (up) {
      spec.artwork_url = up.secure_url; spec.artwork_public_id = up.public_id;
    }, function (err) { console.warn('[pp] order-time artwork upload failed', err); spec.artwork_upload_status = 'failed'; }));
    if (spec.preview_shown === 'yes') tasks.push(withTimeout(Preview.snapshot().then(function (blob) {
      var name = 'preview-' + String(state.artworkFilename || 'logo').replace(/\.[^.]+$/, '').replace(/[^a-z0-9-]+/gi, '-').slice(0, 40) + '.png';
      return uploadArtwork(new File([blob], name, { type: 'image/png' }));
    }), 15000).then(function (up) { spec.preview_image_url = up.secure_url; }, function (err) { console.warn('[pp] preview image upload failed (checkout continues)', err); }));
    await Promise.all(tasks);
    try {
      var signature = await computeHmacHex(payload, root.dataset.signingNonce);
      var res = await fetch(root.dataset.checkoutEndpoint, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(Object.assign({}, payload, { nonce: root.dataset.signingNonce, signature: signature })),
      });
      var data = await res.json();
      if (!res.ok || !data.invoiceUrl) throw new Error(data.error || ('HTTP ' + res.status));
      window.location.href = data.invoiceUrl;
    } catch (e) {
      console.error('[pp] checkout bridge failed', e);
      if (cta) { cta.disabled = false; cta.textContent = restore; }
      alert('Could not start checkout: ' + e.message + '\n\nPlease try again or email support@tapedudes.com.');
    }
  }

  /* ── Coupon (unchanged) ──────────────────────────────────────────────── */

  async function applyDiscountCode(rawCode) {
    var input = $('[data-pp-coupon-input]'), applyBt = $('[data-pp-coupon-apply]'), msg = $('[data-pp-coupon-message]');
    var applied = $('[data-pp-coupon-applied]'), fields = $('[data-pp-coupon-fields]');
    if (!rawCode || !/^[A-Za-z0-9_-]{1,50}$/.test(rawCode.trim())) {
      if (msg) { msg.textContent = 'Please enter a valid code (letters, numbers, hyphens).'; msg.className = 'pp__coupon-msg pp__coupon-msg--error'; }
      return;
    }
    var code = rawCode.trim().toUpperCase();
    if (applyBt) { applyBt.disabled = true; applyBt.textContent = 'Validating…'; }
    if (msg) { msg.textContent = ''; msg.className = 'pp__coupon-msg'; }
    var validationPayload = { action: 'validate-discount', code: code };
    try {
      var signature = await computeHmacHex(validationPayload, root.dataset.signingNonce);
      var res = await fetch(root.dataset.checkoutEndpoint, { method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(Object.assign({}, validationPayload, { nonce: root.dataset.signingNonce, signature: signature })) });
      var data = await res.json();
      if (data.valid) {
        state.discountApplied = { code: data.code, value_type: data.value_type, value: data.value, displayValue: data.displayValue };
        state.discountCode = data.code;
        if (input) input.disabled = true;
        if (applyBt) { applyBt.disabled = true; applyBt.textContent = 'Apply'; }
        if (fields) fields.hidden = true;
        if (applied) { applied.hidden = false; var c = $('[data-pp-coupon-code]'), v = $('[data-pp-coupon-value]'); if (c) c.textContent = data.code; if (v) v.textContent = data.displayValue; }
        renderSummary(); renderCta();
      } else {
        if (msg) { msg.textContent = data.message || 'Invalid coupon code.'; msg.className = 'pp__coupon-msg pp__coupon-msg--error'; }
        if (applyBt) { applyBt.disabled = false; applyBt.textContent = 'Apply'; }
      }
    } catch (e) {
      if (msg) { msg.textContent = "Couldn't validate — try again or apply at checkout."; msg.className = 'pp__coupon-msg pp__coupon-msg--warn'; }
      if (applyBt) { applyBt.disabled = false; applyBt.textContent = 'Apply'; }
    }
  }
  function removeDiscount() {
    state.discountApplied = null; state.discountCode = '';
    var input = $('[data-pp-coupon-input]'), applyBt = $('[data-pp-coupon-apply]'), msg = $('[data-pp-coupon-message]');
    var applied = $('[data-pp-coupon-applied]'), fields = $('[data-pp-coupon-fields]');
    if (input) { input.disabled = false; input.value = ''; }
    if (applyBt) { applyBt.disabled = false; applyBt.textContent = 'Apply'; }
    if (msg) { msg.textContent = ''; msg.className = 'pp__coupon-msg'; }
    if (applied) applied.hidden = true;
    if (fields) fields.hidden = false;
    renderSummary(); renderCta();
  }
  function bindCouponHandlers() {
    var input = $('[data-pp-coupon-input]'), applyBt = $('[data-pp-coupon-apply]'), removeBt = $('[data-pp-coupon-remove]'), noCode = $('[data-pp-coupon-nocode]');
    if (applyBt && input) {
      applyBt.addEventListener('click', function () { applyDiscountCode(input.value); });
      input.addEventListener('keydown', function (e) { if (e.key === 'Enter') applyDiscountCode(input.value); });
    }
    if (removeBt) removeBt.addEventListener('click', removeDiscount);
    if (noCode) noCode.addEventListener('click', function (e) {
      var target = document.querySelector('#td-footer-welcome-signup');
      if (target) { e.preventDefault(); target.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
    });
  }

  /* ══════════════════════════════════════════════════════════════════════
     THE PREVIEW — loaded after the page is interactive, never awaited by anything
     above. Only the SELECTED film × width is loaded (900 first; 1600 on a stage
     wider than 700 px or for zoom). Changing film/width keeps the current image on
     screen until the new set has drawn.
     ══════════════════════════════════════════════════════════════════════ */
  var Preview = (function () {
    var api = { G: null, P: null, I: null, mod: null, ready: false, failed: false, art: null, artFor: null,
      unsupported: false, renderedFor: null, lastGeometry: null, lastSep: null, lastBox: null };
    var canvas = $('[data-pp-canvas]'), photo = $('[data-pp-stage-photo]'), stage = $('[data-pp-stage]');
    var pending = null, running = null;

    // key: '<scene>-<film>-<width>-<size>'; the compact map holds each file's ?v=.
    function plateUrl(key, file) {
      var set = (PLATES.sets || {})[key] || {};
      if (!set[file]) return null;
      var dot = file.lastIndexOf('.');
      return PLATES.base + 'td-tp-pp-' + key + '-' + file.slice(0, dot) + file.slice(dot) + '?v=' + set[file];
    }

    api.boot = function () {
      if (!canvas || !root.dataset.previewGeometry || !root.dataset.previewModule || !root.dataset.previewInks) return;
      var start = function () {
        Promise.all([import(root.dataset.previewGeometry), import(root.dataset.previewModule), import(root.dataset.previewInks)]).then(function (mods) {
          api.G = mods[0]; api.mod = mods[1]; api.I = mods[2];
          api.P = mods[1].createPreview({ G: api.G, inks: api.I, plateUrl: plateUrl });
          api.ready = true;
          if (wantsBig()) { var k0 = baseKey(); api.P.loadPlate(k0 + '-1600').then(function () { big[k0] = true; if (!running) api.go('full'); }, function () {}); }
          renderSizing();
          if (state.artworkFile) api.setFile(state.artworkFile, PREVIEWABLE.some(function (e) { return String(state.artworkFile.name || '').toLowerCase().slice(-e.length) === e; }));
          else api.go('full');
          root.classList.add('pp--preview');
        })['catch'](function (e) {
          api.failed = true;
          console.warn('[pp] preview unavailable — the page works without it', e);
          api.refreshText();
        });
      };
      var idle = window.requestIdleCallback ? function (f) { return window.requestIdleCallback(f, { timeout: 2000 }); } : function (f) { return setTimeout(f, 200); };
      if (document.readyState === 'complete') idle(start);
      else window.addEventListener('load', function () { idle(start); }, { once: true });
    };

    api.setFile = function (file, canPreview) {
      api.art = null; api.artFor = file; api.unsupported = !!file && !canPreview; api.renderedFor = null;
      if (!api.ready || !file || !canPreview) { renderSizing(); api.go('full'); return; }
      api.P.loadArtwork(file).then(function (a) {
        if (api.artFor !== file) return;
        api.art = a;
        renderSizing(); renderSummary();
        api.go('full');
      })['catch'](function (e) {
        if (api.artFor !== file) return;
        console.warn('[pp] could not read that file for the preview', e);
        api.unsupported = true;
        api.go('full');
      });
    };
    api.shownForThisFile = function () { return !!(api.ready && state.artworkFile && api.renderedFor === state.artworkFile && api.art); };

    var big = {}, zoomBig = false;
    function wantsBig() { return !!stage && stage.clientWidth > 700; }
    function baseKey(scene) { return (scene || state.scene) + '-' + filmPlate() + '-' + state.width; }
    function plateSize(mode, k) {
      if (zoomBig) return big[k] ? 1600 : 900;
      if (mode === 'drag' || !wantsBig()) return 900;
      return big[k] ? 1600 : 900;
    }
    api.bigReady = function () { return !!big[baseKey()]; };
    api.onRendered = null;
    api.setZoom = function (on) { zoomBig = !!on; if (zoomBig && !big[baseKey()]) return api.go('full'); return Promise.resolve(); };
    api.renderInto = function (c) {
      if (!api.ready) return Promise.reject(new Error('no preview'));
      var k = baseKey();
      return api.P.render(c, opts(k + '-1600')).then(function (res) { big[k] = true; return res; });
    };
    function opts(plateKey) {
      var e = effective();
      return { plateKey: plateKey, artwork: api.art, layout: e.layout, gapIn: e.gapIn, heightIn: e.heightIn,
        bgHex: e.flood, inks: inkSlots(), line: 'custom-tape', width: widthNum() };
    }

    api.go = function (mode) {
      api.refreshText();
      if (!api.ready) return Promise.resolve();
      pending = mode || 'full';
      if (!running) running = (async function () {
        while (pending) {
          var m = pending; pending = null;
          var k = baseKey(), size = plateSize(m, k);
          try {
            var res = await api.P.render(canvas, opts(k + '-' + size));
            api.lastGeometry = res.geometry; api.lastSep = res.sep; api.lastBox = res.box;
            if (api.art) api.renderedFor = api.artFor;
            canvas.hidden = false;
            if (photo) photo.hidden = true;
            Pin.draw(canvas, res.box);
            if (api.onRendered) api.onRendered(size);
            if (size === 900 && !big[k] && (zoomBig || (m !== 'drag' && wantsBig()))) {
              api.P.loadPlate(k + '-1600').then(function () { big[k] = true; if (running) pending = pending || 'full'; else api.go('full'); }, function () {});
            }
          } catch (err) { console.warn('[pp] preview render failed', err); }
          api.refreshText();
        }
        running = null;
      })();
      return running;
    };

    // The 1600 roll scene, off-screen, for the order (Preview Image).
    api.snapshot = function () {
      if (!api.ready || !api.art) return Promise.reject(new Error('no preview'));
      var c = document.createElement('canvas');
      return api.P.render(c, opts(baseKey('roll') + '-1600')).then(function () {
        return new Promise(function (resolve, reject) { c.toBlob(function (b) { b ? resolve(b) : reject(new Error('toBlob')); }, 'image/png'); });
      });
    };

    api.refreshText = function () {
      var cap = $('[data-pp-caption]');
      var capText = state.scene === 'box' ? (COPY.captionBox || '12 × 12 × 10 in shipping box') : tok(COPY.captionRoll || '%w% in roll, about 4½ in across', { w: widthNum() });
      if (cap) cap.textContent = capText;
      $$('[data-pp-scene]').forEach(function (b) { var on = b.dataset.ppScene === state.scene; b.classList.toggle('is-on', on); b.setAttribute('aria-pressed', on ? 'true' : 'false'); });
      var empty = $('[data-pp-stage-empty]');
      if (empty) empty.hidden = !!state.artworkFile || state.artworkMode === 'text';
      var fc = $('[data-pp-floodcap]');
      if (fc) {
        fc.hidden = state.tapeColorMode !== 'pantone';
        fc.textContent = tok(COPY.floodPantone || 'PANTONE %code% background, matched on your free proof', { code: (state.pantoneTapeCode || '').trim() || '…' });
      }
      var g = api.art ? api.lastGeometry : null;
      var line = specLine(g);
      var sl = $('[data-pp-specline]');
      if (sl) sl.textContent = line.long;
      legend();
      var msgs = messages(g);
      var box = $('[data-pp-msgs]');
      if (box) box.innerHTML = msgs.map(function (m) {
        return '<div class="pp__msg' + (m.warn ? ' pp__msg--warn' : '') + (m.big ? ' pp__msg--big' : '') + '">' +
          (m.warn
            ? '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#C77700" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 4l9 16H3z"/><path d="M12 10v4M12 17v.1"/></svg>'
            : '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#0171CE" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M12 11v5M12 8v.1"/></svg>') +
          '<span class="pp__msg-text">' + esc(m.text) + '</span></div>';
      }).join('');
      // The sketch callout shows on every upload, so it never counts as "a note below".
      Pin.text(capText, line.short, msgs.filter(function (m) { return !m.sketch; }).length);
    };

    function legend() {
      var el = $('[data-pp-legend]');
      if (!el) return;
      var sep = api.art ? api.lastSep : null;
      if (!sep || !sep.plates || !sep.plates.length) { el.innerHTML = ''; return; }
      el.innerHTML = sep.plates.map(function (p) {
        return '<span><i style="background:' + esc(p.paint) + '"></i>' + (p.slot && p.slot.pantone
          ? 'PANTONE ' + esc(p.slot.pantone) + ' <em>(shown in your logo\'s color)</em>' : esc(p.label)) + '</span>';
      }).join('');
    }

    // "Each logo prints X" × Y" · repeats every Z" (n per 8" plate) · about N logos per L yd roll."
    function perRoll(g) {
      var yd = Number(String(state.length).replace(/\D/g, '')) || 110;
      var n = Math.floor(yd * 36 / g.pitchIn) * (g.rows.length > 1 ? 2 : 1);
      if (n > 100) n = Math.round(n / 10) * 10;
      return num(n);
    }
    function specLine(g) {
      if (!g || g.plateTooLong) return { long: '', short: '' };
      var yd = LENGTH_COPY[state.length] || state.length;
      return {
        long: 'Each logo prints ' + r2(g.alongIn) + '" × ' + r2(g.acrossIn) + '" · repeats every ' + r2(g.pitchIn) + '" (' + g.perPlate + ' per 8" plate) · about ' + perRoll(g) + ' logos per ' + yd + ' roll.',
        short: r2(g.acrossIn) + '" tall · every ' + r2(g.pitchIn) + '" · ' + g.perPlate + ' per 8" plate',
      };
    }

    // The honest notes (prototype): no preview, solid background, small file, more
    // colours than inks, longer than the plate. Clear-film contrast is NOT messaged.
    // First, on any previewable upload: the sketch callout (color_note_short, owner
    // 2026-10-15) — it used to sit as loose text under the caption. Same priority as
    // WAT: lead, then the actionable warnings (never dropped). PolyPro has no
    // informational colour note, so the WAT two-callout cap never removes anything here.
    function messages(g) {
      var out = [];
      if (state.artworkFile && !api.unsupported && COPY.msgSketch) out.push({ text: COPY.msgSketch, sketch: true, big: true });
      if (state.artworkFile && api.unsupported) out.push({ text: COPY.msgNoPreview || 'Your logo appears on your free proof.' });
      var a = api.art;
      if (a && g) {
        if (a.solidBg) out.push({ warn: true, text: COPY.msgSolidBg || '' });
        if (!a.vector && api.G && api.G.sourcePpi(g) < 150) out.push({ warn: true, text: COPY.msgSmall || '' });
        var sep = api.lastSep, warn = api.I ? api.I.DELTA_E_WARN : 12;
        if (sep && sep.meanDeltaE > warn) {
          var n = Number(state.printColors);
          out.push({ warn: true, text: tok(COPY.msgMoreColors || '', { n: n + (n === 1 ? ' ink' : ' inks') }) });
        }
        if (g.plateTooLong) out.push({ warn: true, text: COPY.msgTooLong || '' });
      }
      return out;
    }
    return api;
  })();

  /* ══════════════════════════════════════════════════════════════════════
     THE SMALL UI STATE (as WAT): notes, coupon, breakdown, the mobile bottom bar,
     the sticky offsets. Pure presentation.
     ══════════════════════════════════════════════════════════════════════ */
  function renderUi() { if (Ui) Ui.render(); }
  var MOBILE_MQ = '(max-width: 1023px)';
  var Ui = (function () {
    var ui = { notes: false, coupon: false, breakdown: false };
    var api = { ui: ui };
    api.render = function () {
      var nw = $('[data-pp-notes-wrap]'), nt = $('[data-pp-notes-toggle]');
      var notesOn = ui.notes || !!state.designerNotes || state.artworkMode === 'text';
      if (nw) nw.classList.toggle('is-open', notesOn);
      if (nt) { nt.setAttribute('aria-expanded', notesOn ? 'true' : 'false'); nt.hidden = notesOn; }
      var cw = $('[data-pp-coupon-wrap]'), ct = $('[data-pp-coupon-toggle]');
      var couponOn = ui.coupon || !!state.discountApplied;
      if (cw) cw.classList.toggle('is-open', couponOn);
      if (ct) ct.setAttribute('aria-expanded', couponOn ? 'true' : 'false');
      var bd = $('[data-pp-breakdown]'), bt = $('[data-pp-breakdown-toggle]');
      if (bd) bd.classList.toggle('is-open', ui.breakdown);
      if (bt) bt.setAttribute('aria-expanded', ui.breakdown ? 'true' : 'false');
      renderBarTotal();
    };
    function isMobile() { return !!(window.matchMedia && window.matchMedia(MOBILE_MQ).matches); }
    function scrollToCenter(el) {
      if (!el) return;
      var r = el.getBoundingClientRect();
      window.scrollTo({ top: Math.max(0, r.top + window.scrollY - (window.innerHeight - r.height) / 2), behavior: 'smooth' });
    }
    function barCheckout() {
      if (state.artworkMode === 'upload' && !state.artworkFile) {
        dropStatus(COPY.uploadRequired || 'Please upload your artwork to continue.', 'error');
        scrollToCenter($('[data-pp-drop]'));
        return;
      }
      openProofModal();
    }
    api.barCheckout = barCheckout;
    function measureChrome() {
      var stick = 0;
      Array.prototype.forEach.call(document.querySelectorAll('.shopify-section-group-header-group'), function (h) {
        if (/sticky|fixed/.test(getComputedStyle(h).position)) stick = Math.max(stick, Math.round(h.getBoundingClientRect().height));
      });
      var top = Math.round(root.getBoundingClientRect().top + window.scrollY);
      root.style.setProperty('--pp-sticky', Math.min(160, stick) + 'px');
      root.style.setProperty('--pp-chrome', Math.max(0, Math.min(240, top)) + 'px');
    }
    api.bind = function () {
      root.addEventListener('focusin', function (e) {
        var t = e.target;
        if (t.closest && t.closest('[data-pp-notes-wrap]') && !ui.notes) { ui.notes = true; api.render(); }
        if (t.closest && t.closest('[data-pp-coupon-wrap]') && !ui.coupon) { ui.coupon = true; api.render(); }
      }, true);
      var nt = $('[data-pp-notes-toggle]');
      if (nt) nt.addEventListener('click', function () { ui.notes = true; api.render(); var n = $('[data-pp-notes]'); if (n) n.focus(); });
      var ct = $('[data-pp-coupon-toggle]');
      if (ct) ct.addEventListener('click', function () {
        if (state.discountApplied) return;
        ui.coupon = !ui.coupon; api.render();
        if (ui.coupon) { var i = $('[data-pp-coupon-input]'); if (i) i.focus(); }
      });
      var bt = $('[data-pp-breakdown-toggle]');
      if (bt) bt.addEventListener('click', function () { ui.breakdown = !ui.breakdown; api.render(); });
      var bar = $('[data-pp-bar-btn]');
      if (bar) bar.addEventListener('click', barCheckout);
      measureChrome();
      window.addEventListener('resize', measureChrome);
      window.addEventListener('load', measureChrome, { once: true });
      api.render();
    };
    api.isMobile = isMobile;
    return api;
  })();

  /* THE ⓘ POPOVERS — one component (as WAT): the Layout guide and Volume pricing. */
  var Pops = [];
  function makePop(btnSel, popSel, mode) {
    var api = {};
    var btn, pop, pinned = false, timer = 0;
    function canHover() { return !!(window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches) && !Ui.isMobile(); }
    function isOpen() { return !!pop && !pop.hidden; }
    function open() { clearTimeout(timer); if (isOpen()) return; Pops.forEach(function (p) { if (p !== api) p.close(); }); pop.hidden = false; btn.setAttribute('aria-expanded', 'true'); place(); }
    function place() {
      var b = btn.getBoundingClientRect();
      if (Ui.isMobile() || mode === 'above') {
        pop.style.top = '';
        var pr = pop.getBoundingClientRect();
        pop.style.setProperty('--pp-arrow-x', Math.max(12, Math.min(pr.width - 24, Math.round(b.left + b.width / 2 - pr.left - 6))) + 'px');
        return;
      }
      var card = pop.offsetParent || pop.parentNode;
      var cr = card.getBoundingClientRect();
      var h = pop.offsetHeight;
      var header = parseFloat(getComputedStyle(root).getPropertyValue('--pp-sticky')) || 0;
      var top = Math.max(header + 8, Math.min(cr.top + 6, window.innerHeight - 12 - h));
      pop.style.top = Math.round(top - cr.top) + 'px';
      var ay = Math.round(b.top + b.height / 2 - top - 6);
      pop.style.setProperty('--pp-arrow-y', Math.max(12, Math.min(h - 24, ay)) + 'px');
    }
    function close() { clearTimeout(timer); pinned = false; if (!isOpen()) return; pop.hidden = true; btn.setAttribute('aria-expanded', 'false'); }
    function closeSoon() { clearTimeout(timer); if (!pinned) timer = setTimeout(close, 250); }
    api.bind = function () {
      btn = $(btnSel); pop = $(popSel);
      if (!btn || !pop) return;
      Pops.push(api);
      btn.addEventListener('mouseenter', function () { if (canHover()) open(); });
      btn.addEventListener('mouseleave', function () { if (canHover()) closeSoon(); });
      pop.addEventListener('mouseenter', function () { clearTimeout(timer); });
      pop.addEventListener('mouseleave', function () { if (canHover()) closeSoon(); });
      btn.addEventListener('focus', function () { if (canHover()) open(); });
      btn.addEventListener('blur', function () { if (!pinned) closeSoon(); });
      btn.addEventListener('click', function (e) { e.preventDefault(); if (pinned) { close(); return; } open(); pinned = true; });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && isOpen()) { close(); btn.focus(); } });
      document.addEventListener('click', function (e) { if (isOpen() && !pop.contains(e.target) && !btn.contains(e.target)) close(); });
    };
    api.isOpen = isOpen;
    api.open = function () { open(); pinned = true; };
    api.close = close;
    return api;
  }
  var Guide = makePop('[data-pp-info]', '[data-pp-pop]', 'side');
  var QtyPop = makePop('[data-pp-qinfo]', '[data-pp-qpop]', 'side');

  /* ZOOM (as WAT): desktop lens from the 1600 plate; phone full-screen viewer. */
  var Zoom = (function () {
    var api = { on: false, events: [] };
    var SCALE = 2, VMAX = 2.5;
    var btn, stage, canvas, spin, zv, zvStage, zvCanvas, zvSpin, zvClose, opener;
    var ox = 0, oy = 0, raf = 0, stamped = false;
    function clamp(v, a, b) { return Math.max(a, Math.min(b, v)); }
    function stamp(mode) {
      try { if (sessionStorage.getItem('ppZoomOpen')) return; sessionStorage.setItem('ppZoomOpen', '1'); } catch (e) { if (stamped) return; }
      stamped = true;
      var data = { mode: mode, scene: state.scene, film: filmId() };
      api.events.push({ name: 'pp_zoom_open', data: data });
      try { if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') window.Shopify.analytics.publish('pp_zoom_open', data); } catch (e) { /* never breaks the page */ }
    }
    function box() { return { l: canvas.offsetLeft, t: canvas.offsetTop, w: canvas.offsetWidth, h: canvas.offsetHeight }; }
    function localPoint(e) { var r = stage.getBoundingClientRect(), b = box(); return { x: e.clientX - r.left - b.l, y: e.clientY - r.top - b.t }; }
    function setOrigin(x, y) { var b = box(); ox = clamp(x, 0, b.w); oy = clamp(y, 0, b.h); canvas.style.transformOrigin = Math.round(ox) + 'px ' + Math.round(oy) + 'px'; }
    function updateSpin() { if (spin) spin.hidden = !(api.on && !Preview.bigReady()); }
    function setBtn() { if (!btn) return; btn.setAttribute('aria-pressed', api.on ? 'true' : 'false'); btn.setAttribute('aria-label', api.on ? btn.dataset.labelOut : btn.dataset.labelIn); btn.classList.toggle('is-on', api.on); }
    function zoomIn(x, y) { if (api.on) return; setOrigin(x, y); api.on = true; stage.classList.add('is-zoomed'); canvas.style.transform = 'scale(' + SCALE + ')'; setBtn(); Preview.setZoom(true); updateSpin(); stamp('lens'); }
    function zoomOut() { if (!api.on) return; api.on = false; stage.classList.remove('is-zoomed'); canvas.style.transform = ''; setBtn(); Preview.setZoom(false); updateSpin(); }
    api.zoomIn = function (fx, fy) { var b = box(); zoomIn(b.w * (fx == null ? 0.5 : fx), b.h * (fy == null ? 0.5 : fy)); };
    api.zoomOut = zoomOut;
    function overTape(p) {
      var bx = Preview.lastBox, b = box();
      if (!bx || !canvas.width) return true;
      var k = Math.min(b.w, b.h) / canvas.width, dx = (b.w - canvas.width * k) / 2, dy = (b.h - canvas.height * k) / 2;
      var x = dx + bx.x * k, y = dy + bx.y * k;
      return p.x >= x && p.x <= x + bx.w * k && p.y >= y && p.y <= y + bx.h * k;
    }
    var s = 1, tx = 0, ty = 0, pts = new Map(), g = null, lastTap = 0, lastTapAt = null, swipe = 0;
    function vsize() { var r = zvStage.getBoundingClientRect(); return { w: r.width, h: r.height, cw: zvCanvas.offsetWidth, ch: zvCanvas.offsetHeight, cx: r.left + r.width / 2, cy: r.top + r.height / 2 }; }
    function clampT() { var v = vsize(); var mx = Math.max(0, (v.cw * s - v.w) / 2), my = Math.max(0, (v.ch * s - v.h) / 2); tx = clamp(tx, -mx, mx); ty = clamp(ty, -my, my); }
    function apply() { zvCanvas.style.transform = 'translate(' + tx.toFixed(1) + 'px,' + (ty + swipe).toFixed(1) + 'px) scale(' + s.toFixed(3) + ')'; zv.style.setProperty('--pp-zv-fade', String(clamp(1 - swipe / 400, 0.4, 1))); }
    function mid() { var a = Array.from(pts.values()), v = vsize(); var x = 0, y = 0; a.forEach(function (p) { x += p.x; y += p.y; }); return { x: x / a.length - v.cx, y: y / a.length - v.cy }; }
    function dist() { var a = Array.from(pts.values()); return a.length < 2 ? 0 : Math.hypot(a[0].x - a[1].x, a[0].y - a[1].y); }
    function begin() { g = { s: s, tx: tx, ty: ty, m: mid(), d: dist(), n: pts.size, moved: false }; }
    function onDown(e) { zvStage.setPointerCapture && zvStage.setPointerCapture(e.pointerId); pts.set(e.pointerId, { x: e.clientX, y: e.clientY }); begin(); }
    function onMove(e) {
      if (!pts.has(e.pointerId)) return;
      pts.set(e.pointerId, { x: e.clientX, y: e.clientY });
      var m = mid();
      if (Math.hypot(m.x - g.m.x, m.y - g.m.y) > 6) g.moved = true;
      if (pts.size >= 2 && g.d) {
        var ns = clamp(g.s * dist() / g.d, 1, VMAX);
        var cx = (g.m.x - g.tx) / g.s, cy = (g.m.y - g.ty) / g.s;
        s = ns; tx = m.x - cx * ns; ty = m.y - cy * ns; clampT(); apply();
      } else if (pts.size === 1) {
        if (g.s > 1.01) { tx = g.tx + (m.x - g.m.x); ty = g.ty + (m.y - g.m.y); clampT(); apply(); }
        else { var dy = m.y - g.m.y, dx = m.x - g.m.x; swipe = dy > 0 && dy > Math.abs(dx) ? dy : 0; apply(); }
      }
    }
    function onUp(e) {
      if (!pts.has(e.pointerId)) return;
      pts.delete(e.pointerId);
      if (swipe > 90) { swipe = 0; closeViewer(); return; }
      if (swipe) { swipe = 0; apply(); }
      if (!pts.size && g && !g.moved && g.n === 1) {
        var now = Date.now(), p = { x: e.clientX, y: e.clientY };
        if (now - lastTap < 320 && lastTapAt && Math.hypot(p.x - lastTapAt.x, p.y - lastTapAt.y) < 30) {
          var v = vsize(), mx = p.x - v.cx, my = p.y - v.cy;
          if (s > 1.01) { s = 1; tx = 0; ty = 0; } else { s = SCALE; tx = -mx * (SCALE - 1); ty = -my * (SCALE - 1); }
          clampT(); apply(); lastTap = 0;
        } else { lastTap = now; lastTapAt = p; }
      }
      if (pts.size) begin();
    }
    function openViewer() {
      if (!zv || !Preview.ready) return;
      opener = document.activeElement;
      s = 1; tx = 0; ty = 0; swipe = 0; pts.clear(); apply();
      zv.hidden = false;
      document.documentElement.classList.add('pp-zv-open');
      try { zvCanvas.getContext('2d').drawImage(canvas, 0, 0, zvCanvas.width, zvCanvas.height); } catch (e) { /* not drawn yet */ }
      if (zvSpin) zvSpin.hidden = false;
      Preview.renderInto(zvCanvas).then(function () { if (zvSpin) zvSpin.hidden = true; }, function () { if (zvSpin) zvSpin.hidden = true; });
      if (zvClose) zvClose.focus();
      api.viewerOpen = true;
      stamp('viewer');
    }
    function closeViewer() {
      if (!zv || zv.hidden) return;
      zv.hidden = true; api.viewerOpen = false;
      document.documentElement.classList.remove('pp-zv-open');
      if (opener && opener.focus) opener.focus();
    }
    api.openViewer = openViewer; api.closeViewer = closeViewer;
    api.bind = function () {
      btn = $('[data-pp-zoom]'); stage = $('[data-pp-stage]'); canvas = $('[data-pp-canvas]'); spin = $('[data-pp-zoom-spin]');
      zv = $('[data-pp-zv]'); zvStage = $('[data-pp-zv-stage]'); zvCanvas = $('[data-pp-zv-canvas]'); zvSpin = $('[data-pp-zv-spin]'); zvClose = $('[data-pp-zv-close]');
      if (!btn || !stage || !canvas) return;
      Preview.onRendered = function () { btn.hidden = false; updateSpin(); };
      canvas.addEventListener('click', function (e) { if (Ui.isMobile()) { openViewer(); return; } if (api.on) zoomOut(); else { var p = localPoint(e); zoomIn(p.x, p.y); } });
      btn.addEventListener('click', function () { if (Ui.isMobile()) { openViewer(); return; } if (api.on) zoomOut(); else api.zoomIn(); });
      btn.addEventListener('keydown', function (e) {
        if (!api.on) return;
        var d = { ArrowLeft: [-40, 0], ArrowRight: [40, 0], ArrowUp: [0, -40], ArrowDown: [0, 40] }[e.key];
        if (d) { e.preventDefault(); setOrigin(ox + d[0], oy + d[1]); }
      });
      stage.addEventListener('mousemove', function (e) {
        var p = localPoint(e);
        if (!api.on) { canvas.style.cursor = overTape(p) ? 'zoom-in' : ''; return; }
        if (raf) return;
        raf = requestAnimationFrame(function () { raf = 0; setOrigin(p.x, p.y); });
      });
      document.addEventListener('keydown', function (e) { if (e.key !== 'Escape') return; if (api.viewerOpen) { e.preventDefault(); closeViewer(); } else if (api.on) zoomOut(); });
      window.addEventListener('resize', function () { if (api.on && Ui.isMobile()) zoomOut(); });
      if (zv && zvStage && zvCanvas) {
        zvStage.addEventListener('pointerdown', onDown); zvStage.addEventListener('pointermove', onMove);
        zvStage.addEventListener('pointerup', onUp); zvStage.addEventListener('pointercancel', onUp);
        if (zvClose) zvClose.addEventListener('click', closeViewer);
        zv.addEventListener('keydown', function (e) { if (e.key === 'Tab') { e.preventDefault(); if (zvClose) zvClose.focus(); } });
      }
    };
    return api;
  })();

  /* THE PINNED PREVIEW (mobile, as WAT). */
  var Pin = (function () {
    var pin = $('[data-pp-pin]'), pc = $('[data-pp-pin-canvas]');
    var api = { on: false };
    var mq = window.matchMedia ? window.matchMedia(MOBILE_MQ) : { matches: false };
    var typing = false;
    function update() {
      if (!pin) return;
      var stageEl = $('[data-pp-pv]'), cards = $('[data-pp-dock]');
      var want = false;
      if (mq.matches && stageEl && cards && !typing && !Preview.failed) {
        want = stageEl.getBoundingClientRect().bottom < 40 && cards.getBoundingClientRect().bottom > 260;
      }
      if (want !== api.on) {
        api.on = want; pin.hidden = !want; pin.setAttribute('aria-hidden', want ? 'false' : 'true');
        document.documentElement.classList.toggle('pp-pinned', want);
        if (want) document.documentElement.style.setProperty('--pp-pin-h', pin.offsetHeight + 'px');
      }
    }
    api.bind = function () {
      if (!pin) return;
      var raf = 0;
      var onScroll = function () { if (!raf) raf = requestAnimationFrame(function () { raf = 0; update(); }); };
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll);
      root.addEventListener('focusin', function (e) {
        var t = e.target;
        var isText = t && (t.tagName === 'TEXTAREA' || (t.tagName === 'INPUT' && /^(text|search|email|tel|number)$/i.test(t.type || 'text')));
        if (isText) { typing = true; update(); return; }
        if (!api.on || pin.contains(t)) return;
        var r = t.getBoundingClientRect(), h = pin.offsetHeight;
        if (r.top < h + 8) window.scrollBy({ top: r.top - h - 16, behavior: 'auto' });
      });
      root.addEventListener('focusout', function () { typing = false; setTimeout(update, 50); });
      update();
    };
    api.draw = function (src, box) {
      if (!pc || !src || !src.width) return;
      var W = pc.width, H = pc.height, x = pc.getContext('2d');
      x.fillStyle = '#FBF9F6'; x.fillRect(0, 0, W, H);
      var b = box || { x: 0, y: 0, w: src.width, h: src.height };
      var pad = 0.16 * Math.max(b.w, b.h);
      var sx = Math.max(0, b.x - pad), sy = Math.max(0, b.y - pad);
      var sw = Math.min(src.width - sx, b.w + 2 * pad), sh = Math.min(src.height - sy, b.h + 2 * pad);
      var k = Math.min(W / sw, H / sh), dw = sw * k, dh = sh * k;
      x.drawImage(src, sx, sy, sw, sh, (W - dw) / 2, (H - dh) / 2, dw, dh);
    };
    api.text = function (caption, specShort, nMsgs) {
      var s = $('[data-pp-pin-spec]'); if (s) s.textContent = specShort;
      var m = $('[data-pp-pin-msg]');
      if (m) { m.hidden = !nMsgs; m.textContent = nMsgs === 1 ? (COPY.pinNotesOne || '1 note below the preview') : nMsgs + ' ' + (COPY.pinNotesMany || 'notes below the preview'); }
    };
    return api;
  })();

  /* Exposed for QA only. Never used by the page itself. */
  window.__pp = function () {
    return {
      skuKey: skuKey(), qty: state.qty, tiers: currentTiers(), visible: visibleTiers(), minRolls: minRolls(),
      each: priceEach(), subtotal: tapeSubtotal(), pantone: pantonePrintFee() + pantoneTapeFee(),
      total: totalPrice(), charged: chargedTotal(), qtyValid: qtyValid(),
      film: filmId(), plate: filmPlate(), flood: floodHex(), inks: inkSlots(), orient: state.orient, scene: state.scene,
      effective: effective(), buildSpec: buildSpec, state: state,
      setQty: setQty, setFilm: setFilm, setOrient: setOrient, renderAll: renderAll,
      preview: { ready: Preview.ready, failed: Preview.failed, shown: Preview.shownForThisFile(), geometry: Preview.lastGeometry, sep: Preview.lastSep, pinned: Pin.on },
    };
  };
  window.__ppPreview = Preview;
  window.__ppUi = Ui;
  window.__ppGuide = Guide;
  window.__ppQtyPop = QtyPop;
  window.__ppZoom = Zoom;
})();
